import { ValueNode } from './ValueNode';
export class AnnotationNode extends ValueNode {
    constructor(id, value, key, metadata, attributes = []) {
        super(id, key, metadata);
        this.originalEdges = new Map();
        this.value = value;
        this.attributes = attributes;
    }
    clearOriginalEdges() {
        this.originalEdges = new Map();
    }
    addOriginalEdge(edge) {
        this.originalEdges.set(edge.to, edge);
    }
    getOriginalEdge(targetId) {
        return this.originalEdges.get(targetId);
    }
    getOriginalEdges() {
        return this.originalEdges;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub3RhdGlvbk5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL3JlY29yZC9Bbm5vdGF0aW9uTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBS3ZDLE1BQU0sT0FBTyxjQUVYLFNBQVEsU0FBUztJQUtqQixZQUNFLEVBQVUsRUFDVixLQUFhLEVBQ2IsR0FBWSxFQUNaLFFBQW1CLEVBQ25CLGFBQStCLEVBQUU7UUFFakMsS0FBSyxDQUFDLEVBQUUsRUFBRSxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUE7UUFUbEIsa0JBQWEsR0FBc0IsSUFBSSxHQUFHLEVBQUUsQ0FBQTtRQVVsRCxJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQTtJQUM5QixDQUFDO0lBRU0sa0JBQWtCO1FBQ3ZCLElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxHQUFHLEVBQUUsQ0FBQTtJQUNoQyxDQUFDO0lBRU0sZUFBZSxDQUFDLElBQVU7UUFDL0IsSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsRUFBRSxJQUFJLENBQUMsQ0FBQTtJQUN2QyxDQUFDO0lBRU0sZUFBZSxDQUFDLFFBQWdCO1FBQ3JDLE9BQU8sSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsUUFBUSxDQUFDLENBQUE7SUFDekMsQ0FBQztJQUVNLGdCQUFnQjtRQUNyQixPQUFPLElBQUksQ0FBQyxhQUFhLENBQUE7SUFDM0IsQ0FBQztDQUNGIn0=